import confetti from 'canvas-confetti';
import { format } from 'date-fns';
import React, { FC, useEffect } from 'react';
import { IoShareSocialSharp } from "react-icons/io5";
import { useEventContext } from '../../context/EventProvider';
import AddToCal from '../addToCalendar';

const Confirmation: FC = () => {
  const {
    event: { starts, emailSubject, url, siteName }
  } = useEventContext();

  useEffect(() => {
    const canvas = document.getElementById(
      'confetti'
    ) as HTMLCanvasElement | null;

    if (canvas) {
      const myConfetti = confetti.create(canvas, {
        resize: true
      });

      const duration = 2.5 * 1000;
      const animationEnd = Date.now() + duration;
      let skew = 1;

      function randomInRange(min: number, max: number) {
        return Math.random() * (max - min) + min;
      }

      (function frame() {
        const timeLeft = animationEnd - Date.now();
        const ticks = Math.max(200, 500 * (timeLeft / duration));
        skew = Math.max(0.8, skew - 0.001);
        const colors = [
          '#5d3682',
          '#797834',
          '#784d6b',
          '#017141',
          '#277082',
          '#752c2d'
        ];
        const config: confetti.Options = {
          particleCount: 1,
          startVelocity: -3,
          ticks,
          origin: {
            x: Math.random(),
            // since particles fall down, skew start toward the top
            y: Math.random() * skew - 0.2
          },
          colors: [colors[Math.floor(Math.random() * colors.length)]],
          shapes: ['square'],
          gravity: randomInRange(0.4, 0.6),
          scalar: randomInRange(0.8, 1.3),
          drift: randomInRange(-0.4, 0.4)
        };

        myConfetti(config);

        if (timeLeft > 0) {
          requestAnimationFrame(frame);
        }
      })();
    }
  }, []);

  const startDateUtc = new Date(starts);
  const formattedStartDate = format(startDateUtc, 'MMMM d, yyyy', {});

  const Link = ({
    text,
    href,
    className,
    share
  }: {
    text: string;
    href: string;
    className?: string;
    share?: boolean;
  }) => (
    <a href={href} target="_blank" className={`${className} no-underline w-36`}>
      {share && <IoShareSocialSharp />}&nbsp;&nbsp;
      {text.toUpperCase()}
    </a>
  );

  return (
    <div className="confirmation-modal">
      <canvas id="confetti"></canvas>
      <div className="confirmation-content">
        <h1>That's it!</h1>
        <h2>
          Thank you for registering for the{' '}
          <span className="text-red-500">{siteName}</span>
        </h2>
        <p className="pb-3">
          <AddToCal />
        </p>
        <p className='text-red-500'>{formattedStartDate}</p>
        <p className="pb-4">
          Spread the word. Invite a colleague to {siteName}.
        </p>
        <div className='my-4'>
          <Link
            text="share invite"
            href={`mailto:?subject=${emailSubject} | ${formattedStartDate}&body=Wow! Check out this really cool event coming up soon from SNG: ${url}`}
            share
            className="invite-button mx-3"
            />
          <Link
            text="explore more"
            href="https://cyberscoop.com/attend/"
            className="text-black explore-button mx-3"
          />
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
